itsoftApp.createModule("lazyLoading", function () {
    const module = this;

    const Lazy = function () {
        this.path = "/assets/scripts/vanilla-lazyload/lazyload.min.js";

        this.init();
    };

    Lazy.prototype.setSettings = function () {
        new LazyLoad({ // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".lazy, .lazyload", // eslint-disable-line
            class_loaded: "loaded" // eslint-disable-line
        });
    };

    Lazy.prototype.init = function () {
        itsoftApp.loadScript(this.path, this.setSettings);
    };

    new Lazy();
    module.callback = Lazy;
});
